import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {CommonModule} from '@angular/common';

import {IonicModule} from '@ionic/angular';
import {FooterMenuComponent} from "@components/footerMenu/footer-menu.component";
import {FooterTruncPipe} from "@components/footerMenu/footer-trunc.pipe";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],

  //providers:[FooterTruncPipe],
  declarations: [FooterMenuComponent,
    FooterTruncPipe
  ],
  exports: [
    FooterMenuComponent,
    FooterTruncPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class FooterMenuModule {
}
